module.exports = __webpack_public_path__ + "0ead6ee133c117bbfe5393993eec845d.MP3";